import { useEffect, useState } from "react";
import { api, errorText, type User } from "../lib/api.ts";

/** Invite link format: /invite#token=… (fragment: never sent to the server in logs/referrers). */
function inviteTokenFromUrl(): string | null {
  const params = new URLSearchParams(location.hash.slice(1));
  return params.get("token");
}

export function InvitePage({ onRegistered }: { onRegistered: (u: User) => void }) {
  const [token] = useState(inviteTokenFromUrl);
  const [valid, setValid] = useState<boolean | null>(null);
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) {
      setValid(false);
      return;
    }
    api
      .checkInvite(token)
      .then((r) => setValid(r.valid))
      .catch(() => setValid(false));
  }, [token]);

  const register = async () => {
    if (!token) return;
    setBusy(true);
    setError(null);
    try {
      const user = await api.register(token, name.trim());
      history.replaceState(null, "", "/");
      onRegistered(user);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="center">
      <div className="card">
        <h1>Welcome to racler.dev</h1>
        {valid === null && <p className="muted">Checking invite…</p>}
        {valid === false && <p className="error">This invite link is invalid, expired or already used.</p>}
        {valid && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              void register();
            }}
          >
            <label>
              Display name
              <input
                autoFocus
                value={name}
                maxLength={100}
                onChange={(e) => setName(e.target.value)}
                placeholder="Tim"
                data-testid="display-name"
              />
            </label>
            <button className="primary" disabled={busy || name.trim() === ""} data-testid="register">
              {busy ? "Waiting for passkey…" : "Create passkey & account"}
            </button>
          </form>
        )}
        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );
}
